import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        maxWidth: '800px',
        width: '90%',
        maxHeight: '90vh',
    },
}));

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2, 3),
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
    padding: theme.spacing(3),
    '& .MuiTypography-root': {
        marginBottom: theme.spacing(2),
    },
}));

function TermsModal({ open, onClose }) {
    return (
        <StyledDialog
            open={open}
            onClose={onClose}
            aria-labelledby="terms-dialog-title"
            scroll="paper"
        >
            <StyledDialogTitle>
                <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold' }}>
                    Rahoituskanava.fi käyttöehdot
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </StyledDialogTitle>
            
            <StyledDialogContent>
                <Typography variant="body1" paragraph>
                    Tätä verkkopalvelua hyväksyt seuraavat käyttöehdot. Mikäli et hyväksy näitä ehtoja, pyydämme sinua olemaan käyttämättä palveluamme.
                </Typography>

                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
                    1. Palvelun kuvaus
                </Typography>
                <Typography variant="body1" paragraph>
                    Rahoituskanava.fi on rahoituspalveluiden kilpailutuspalvelu, joka auttaa yrityksiä löytämään parhaat rahoitusratkaisut. Palvelumme välittää hakemuksesi useille rahoituslaitoksille ja auttaa sinua vertailemaan saamiasi tarjouksia.
                </Typography>

                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
                    2. Palvelun käyttö
                </Typography>
                <Typography variant="body1" paragraph>
                    Palvelua käyttäessäsi sitoudut käyttämään sitä vain laillisiin tarkoituksiin. Vastaat siitä, että antamasi tiedot ovat oikeita ja ajantasaisia. Palvelun käyttö on ilmaista ja sitoumuksetonta.
                </Typography>

                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
                    3. Henkilötietojen käsittely
                </Typography>
                <Typography variant="body1" paragraph>
                    Käsittelemme henkilötietojasi tietosuojaselosteemme mukaisesti. Antamasi tiedot välitetään rahoituslaitoksille, jotta he voivat antaa sinulle tarjouksia. Lisätietoja henkilötietojen käsittelystä löydät tietosuojaselosteestamme.
                </Typography>

                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
                    4. Vastuunrajoitukset
                </Typography>
                <Typography variant="body1" paragraph>
                    Rahoituskanava.fi ei vastaa rahoituslaitosten antamista tarjouksista tai niiden toteutumisesta. Vastuunrajoitukset koskevat myös mahdollisia virheitä tai puutteita palvelun sisällössä.
                </Typography>

                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
                    5. Palvelun muutokset
                </Typography>
                <Typography variant="body1" paragraph>
                    Pidätämme oikeuden muuttaa palveluamme ja näitä käyttöehtoja. Muutoksista ilmoitetaan palvelussa. Palvelun käyttö muutosten jälkeen tarkoittaa käyttöehtojen hyväksymistä.
                </Typography>

                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
                    6. Yhteystiedot
                </Typography>
                <Typography variant="body1" paragraph>
                    Jos sinulla on kysyttävää palvelusta tai käyttöehdoista, ota yhteyttä meihin. Yhteystietomme löydät palvelun yhteystiedot -osiosta.
                </Typography>

                <Typography variant="body2" sx={{ mt: 4, fontStyle: 'italic', color: 'text.secondary' }}>
                    Käyttöehdot päivitetty viimeksi: {new Date().toLocaleDateString('fi-FI')}
                </Typography>
            </StyledDialogContent>
            
            <DialogActions sx={{ padding: 2, borderTop: 1, borderColor: 'divider' }}>
                <Button onClick={onClose} variant="contained" color="primary">
                    Sulje
                </Button>
            </DialogActions>
        </StyledDialog>
    );
}

export default TermsModal; 